
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/templates",
      function () {
        return require("private-next-pages/clm/templates/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clm/templates"])
      });
    }
  